import React from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  NavbarText,
  DropdownItem } from 'reactstrap';
import Lib from "../../../../commons/lib";
import RendelesPortal from './RendelesPortal';
import SvgViewer from '../../../../commons/SvgViewer';
import { saveLocale, getLocale } from '../../transInit';
import { t } from 'ttag';

const imgUrl = window.location.origin + process.env.PUBLIC_URL + '/img/logo_kultik.png';

const setLocale = (locale) => (ev) => {
  ev.preventDefault();
  saveLocale(locale);
  window.location.reload();
}

export default class Header extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      isPortalOpen: false,
      toggle: false,
      isSecondScreenButtonActive: false,
      renderHeader: false
    };

  }

  componentDidMount() {
    this.setState({
      isSecondScreenButtonActive: !window.location.pathname.startsWith(process.env.PUBLIC_URL+'/event/'),
      renderHeader: !window.location.pathname.startsWith(process.env.PUBLIC_URL+'/admin/kulsomonitor'),
    }, () => {
    if(!this.state.renderHeader) {
      document.body.style.paddingTop = "0px";
      }
    });
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  logout = () => {
    // window.location.href = 'https://www.index.hu'
    // self.close()
  }

  toggleFullscreen = () => {
    let docElm = document.documentElement;
    if (typeof document.fullscreen === 'boolean') {
      if (document.fullscreen) document.exitFullscreen();
      else docElm.requestFullscreen();
    } else if (typeof document.mozFullScreen === 'boolean') {
      if (document.mozFullScreen) document.mozCancelFullScreen();
      else docElm.mozRequestFullScreen();
    } else if (typeof document.webkitIsFullScreen === 'boolean') {
      if (document.webkitIsFullScreen) document.webkitCancelFullScreen();
      else docElm.webkitRequestFullScreen();
    } else if (typeof document.msFullscreenElement === 'boolean') {
      if (document.msFullscreenElement) document.msExitFullscreen();
      else docElm.msRequestFullscreen();
    }
  }

  emptyFormatter = (data) => {
    if(!data || data === '') return '-';
    return data;
  }

  togglePortal = () =>{
    this.setState({
      isPortalOpen: !this.state.isPortalOpen
    })

    // console.log('SEC');
    window.setInterval(function(){
      Lib.MicroServices.updateToken(10);
    }, 1000);
  }

  render() {
    return (
      <div>
      {this.state.renderHeader && (
      <div>
        <Navbar expand="md" >
          <NavbarBrand id="navbar-brand" href="">
            <img
              src={process.env.PUBLIC_URL + '/img/logo.png'}
              className="logo"
              alt="logo"
              id='headerLogo'
            />
            <h1 className="szlogen">Foglalj helyet!</h1>
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle}>
            <i className="fa fa-navicon" />
          </NavbarToggler>
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              {/* <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>
                { t`Események` }
                </DropdownToggle>
                <DropdownMenu end>
                  <DropdownItem>
                  { t`Színház` }
                  </DropdownItem>
                  <DropdownItem>
                  { t`Zene` }
                  </DropdownItem>
                  <DropdownItem>
                  { t`Családi` }
                  </DropdownItem>
                  <DropdownItem>
                  { t`Fesztivál` }
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown> */}
              {/* <NavItem>
                <NavLink href={`${this.props.globals.public_url}/admin/`}>{ t`Admin` }</NavLink>
              </NavItem> */}
              {/* <NavItem>
                <NavLink href={`${this.props.globals.public_url}/kapcsolat/`}>{ t`Kapcsolat` }</NavLink>
              </NavItem> */}
              {/* <NavItem>
                  <NavLink href='/' onClick={setLocale('hu')}>hu</NavLink>
              </NavItem>
              <NavItem>
                  <NavLink href='/' onClick={setLocale('en')}>en</NavLink>
              </NavItem> */}
              <UncontrolledDropdown nav inNavbar style={{ marginRight: 10 }}>
                <DropdownToggle nav caret>
                  <span className={"flag-icon flag-icon-" + (getLocale() === 'en' ? 'gb' : getLocale())} />
                </DropdownToggle>
                <DropdownMenu end>
                  <DropdownItem onClick={setLocale('hu')}>
                    <span className="flag-icon flag-icon-hu" />
                    {' Magyar'}
                  </DropdownItem>
                  <DropdownItem onClick={setLocale('en')}>
                    <span className="flag-icon flag-icon-gb" />
                    {' English'}
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown>
                {/*<DropdownToggle
                  className="header-button nav-head"
                  style={{
                    backgroundColor: '#fff0',
                    borderColor: '#fff',
                    color: 'white',
                    width: '200px',
                    border: 'none',
                    wordBreak: 'break-all',
                    whiteSpace: 'normal'
                  }}
                  caret
                >
                  <i className="fa fa-user" aria-hidden="true"></i>
                  <span
                    className="hidden-md-down"
                  >
                  {' '}
                  Teszt Elek
                  </span>
                </DropdownToggle> */}
                <DropdownMenu end>
                  {/* <DropdownItem header className="text-center"><strong>Fiók</strong></DropdownItem>
                  <DropdownItem><i className="fa fa-bell-o"></i> Értesítések<span className="badge badge-danger">5</span></DropdownItem>
                  <DropdownItem header className="text-center"><strong>Beállítások</strong></DropdownItem>
                  <DropdownItem><i className="fa fa-user"></i> Profil</DropdownItem>
                  <DropdownItem><i className="fa fa-wrench"></i> Beállítások</DropdownItem>
                  <DropdownItem divider /> */}
                  {/* <DropdownItem><i className="fa fa-shield"></i> Lezárás</DropdownItem> */}
                  <DropdownItem header className="text-center"><strong>Fiók</strong></DropdownItem>
                  {/* <DropdownItem onClick={this.navToSettings} className="nav-head"><i className="fa fa-cog" /> Beállítások</DropdownItem> */}
                  <DropdownItem onClick={this.toggleFullscreen} className="nav-head">
                    <i className="fa fa-arrows-alt" />
                    {'Teljes képernyő ki/be'}
                  </DropdownItem>
                  <DropdownItem onClick={this.logout} className="nav-head">
                    <i className="fa fa-lock" />
                    {'Kilépés'}
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
      )}
      </div>
    );
  }
}